import { Environment } from './shared-types'

import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

export default (appContext) => {
  const stimulus = Application.start()
  // Configure Stimulus development experience
  stimulus.debug = appContext.environment === Environment.Development
  window.Stimulus = stimulus

  const applicationContext = requireApplicationContext()
  const viewComponentsContext = requireViewComponentsContext()

  window.Stimulus.load(definitionsFromContext(applicationContext))
  window.Stimulus.load(definitionsFromContext(viewComponentsContext))

  // Enable HMR for Stimulus controllers
  /* eslint-disable no-undef */
  if (module.hot) {
    module.hot.accept(applicationContext.id, () => {
      window.Stimulus.load(definitionsFromContext(requireApplicationContext()))
    })

    module.hot.accept(viewComponentsContext.id, () => {
      window.Stimulus.load(
        definitionsFromContext(requireViewComponentsContext())
      )
    })
  }
  /* eslint-enable no-undef */

  return appContext
}

function requireApplicationContext() {
  // eslint-disable-next-line no-undef
  return require.context('../../controllers', true, /\.(js|ts)$/)
}

function requireViewComponentsContext() {
  // eslint-disable-next-line no-undef
  return require.context('../../../components', true, /controller\.(js|ts)$/)
}
